import React from 'react';
import Badge, { BadgeProps } from '@mui/material/Badge';
import { makeStyles } from '~/UIKit/Style';
import cn from 'classnames';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'grid',
    maxWidth: '100%',
    gridTemplateColumns: '1fr 10px',
  },
  content: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '> *': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  hasBadge: {
    paddingRight: 25,
  },
  badge: {
    '& .MuiBadge-badge': {
      top: '50%',
      transform: 'translate(25px, -50%)',
      minWidth: 25,
      maxHeight: 18,
    },
  },
}));

export const FilterBadge = ({ children, className, ...props }: BadgeProps) => {
  const { classes } = useStyles();

  return (
    <div className={cn(classes.container, { [classes.hasBadge]: props.badgeContent })}>
      <div className={classes.content}>{children}</div>
      {props.badgeContent ? (
        <Badge className={cn(classes.badge, className)} color="primary" {...props} />
      ) : null}
    </div>
  );
};
